import Body from '../components/Body';

export default function LoginPage() {
	return (
		<Body>
			<h1>Login form</h1>
			<p>TODO</p>
		</Body>
	);
}